import { render, staticRenderFns } from "./addCoverPopup.vue?vue&type=template&id=610923ca&scoped=true"
import script from "./addCoverPopup.vue?vue&type=script&lang=js"
export * from "./addCoverPopup.vue?vue&type=script&lang=js"
import style0 from "./addCoverPopup.vue?vue&type=style&index=0&id=610923ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610923ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610923ca')) {
      api.createRecord('610923ca', component.options)
    } else {
      api.reload('610923ca', component.options)
    }
    module.hot.accept("./addCoverPopup.vue?vue&type=template&id=610923ca&scoped=true", function () {
      api.rerender('610923ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mediaManage/mediaContentManage/editDialog_componts/coverComponents/addCoverPopup.vue"
export default component.exports